export default "__VITE_ASSET__BLRBlIKE__"